"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var excludes_exports = {};
__export(excludes_exports, {
  findExcludedMarks: () => findExcludedMarks
});
module.exports = __toCommonJS(excludes_exports);
var import_text_core = require("@hcengineering/text-core");
function findExcludedMarks(schema, names) {
  const kept = [];
  const excluded = [];
  names.forEach((name, index) => {
    const type = schema.marks[(0, import_text_core.stripHash)(name)];
    if (type === void 0) return;
    if (kept.some((k) => k.excludes(type) || type.excludes(k))) {
      excluded.push(index);
    } else {
      kept.push(type);
    }
  });
  return excluded;
}
__name(findExcludedMarks, "findExcludedMarks");
//# sourceMappingURL=excludes.js.map
